/* file: src/pages/BlogAdmin/BlogGenerator.js */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';

import './BlogGenerator.css';

const BlogGenerator = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/blog-articles`);
      let articlesData = response.data;
      if (!Array.isArray(articlesData)) {
        if (typeof articlesData === 'string') {
          try {
            articlesData = JSON.parse(articlesData);
          } catch (e) {
            console.error('Fehler beim Parsen der Artikel:', e);
            articlesData = [];
          }
        } else if (articlesData && Array.isArray(articlesData.articles)) {
          articlesData = articlesData.articles;
        } else {
          articlesData = [];
        }
      }
      setArticles(articlesData);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setArticles([]);
    }
  };

  return (
    <div className="blog-admin-card">
      <div>
        <h2>Blog Generierung</h2>
        <p className="blog-admin-section-copy">
          Rohartikel und kontextualisierte Fassung bleiben als Redaktions-Vorschau innerhalb derselben Admin-Familie sichtbar.
        </p>
      </div>
      <div className="blog-admin-articles">
        {Array.isArray(articles) && articles.length ? articles.map((article) => (
          <article key={article.id} className="blog-admin-article">
            <div className="blog-admin-article-copy">
              <h3>{article.title || "Ohne Titel"}</h3>
              <p className="blog-admin-meta">
                Quelle: {article.source || "-"} | {article.publishedAt ? new Date(article.publishedAt).toLocaleString() : "-"}
              </p>
            </div>
            <div className="blog-admin-article-preview">
              <section className="blog-admin-article-panel">
                <h3>Original</h3>
                <p>{article.content || "Kein Inhalt vorhanden."}</p>
              </section>
              <section className="blog-admin-article-panel">
                <h3>Kontextualisierte Version</h3>
                <p>{`[Experten4Germany Kontext] ${article.content || ""}`}</p>
              </section>
            </div>
          </article>
        )) : (
          <div className="blog-admin-empty">Keine Artikel fuer die Vorschau gefunden.</div>
        )}
      </div>
    </div>
  );
};

export default BlogGenerator;
